/*
 * Cross-sell - moteur cross-sell unique (grille + encart + tiroir).
 * Lecture panier: GET /cart.js SEUL. Aucun POST custom, aucun preventDefault sur l'ajout :
 * les CTA passent par le {% form 'product' %} natif (voir snippets/mx-xsell-row.liquid).
 * Filtrage synchrone par atomes: on masque tout candidat partageant un atome avec le panier.
 * Chargé une fois globalement via snippets/mx-xsell-head.liquid.
 */
(function () {
  if (window.__mxXsell) return;
  window.__mxXsell = true;

  var ATOMS = window.MX_ATOMS || {};

  function parseAtoms(str) {
    try { var a = JSON.parse(str || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function getCart(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () { cb({ items: [], item_count: 0 }); });
  }
  // Construit l'ensemble POSSEDE (atomes) + les handles deja au panier.
  function ownedFromCart(cart, currentAtoms) {
    var owned = Object.create(null);
    var handles = Object.create(null);
    (cart.items || []).forEach(function (it) {
      handles[it.handle] = 1;
      var a = ATOMS[it.product_id] || ATOMS[String(it.product_id)] || [String(it.product_id)];
      a.forEach(function (x) { owned[x] = 1; });
    });
    (currentAtoms || []).forEach(function (x) { owned[x] = 1; });
    return { owned: owned, handles: handles };
  }
  function suppressed(cand, ctx, current, noPacks) {
    if (current && cand.handle === current) return true;
    if (ctx.handles[cand.handle]) return true;
    if (noPacks && cand.pack) return true;
    for (var i = 0; i < cand.atoms.length; i++) {
      if (ctx.owned[cand.atoms[i]]) return true;
    }
    return false;
  }
  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  function esc(s) {
    s = String(s == null ? '' : s);
    return s.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
  }
  function cartToken(cart) {
    return (cart.item_count || 0) + ':' + (cart.items || []).map(function (i) { return i.id + 'x' + i.quantity; }).join(',');
  }

  /* ---------- GRILLE bas de fiche (recommandations ; cartes-lien ; packs autorises) ---------- */
  function card(p) {
    var media = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" loading="lazy">'
                      : '<span class="mx-xsell-shopcard__ph">' + esc(p.t) + '</span>';
    // Extras : seconde image au survol + vignette produit component (+)
    var hover = p.img2 ? '<span class="mx-xsell-hover" aria-hidden="true"><img src="' + esc(p.img2) + '" alt="" loading="lazy"></span>' : '';
    var comp = p.comp ? '<span class="mx-xsell-comp" aria-hidden="true"><span class="mx-xsell-comp__plus">+</span><span class="mx-xsell-comp__img"><img src="' + esc(p.comp) + '" alt="" loading="lazy"></span></span>' : '';
    return '<a class="mx-xsell-shopcard" href="' + esc(p.u) + '">'
      + '<div class="mx-xsell-shopcard__media">' + media + hover + comp + '</div>'
      + '<div class="mx-xsell-shopcard__cap"><span class="mx-xsell-shopcard__name">' + esc(p.t) + '</span>'
      + '<span class="mx-xsell-shopcard__price">' + esc(p.pr) + '</span></div></a>';
  }
  function grid() {
    var host = document.querySelector('[data-mx-xsell-grid]');
    if (!host) return;
    var poolEl = host.querySelector('[data-mx-xsell-grid-pool]');
    var listEl = host.querySelector('[data-mx-xsell-grid-list]');
    if (!poolEl || !listEl) return;
    var pool = [];
    try { pool = JSON.parse(poolEl.textContent) || []; } catch (e) { pool = []; }
    if (!pool.length) { host.hidden = true; return; }
    var current = host.getAttribute('data-current') || currentHandle();
    var max = parseInt(host.getAttribute('data-max') || '4', 10);
    var min = parseInt(host.getAttribute('data-min') || '1', 10);
    /* Atomes de la fiche courante : lus sur l'hote (data-atoms rendu serveur = mx-xsell.bundle_atoms du produit),
       pour que le filtrage tienne compte du produit visite (pack inclus) meme s'il n'est pas dans le pool. */
    var currentAtoms = parseAtoms(host.getAttribute('data-atoms'));
    if (!currentAtoms.length) pool.forEach(function (p) { if (p.h === current) currentAtoms = p.a || []; });
    getCart(function (cart) {
      var ctx = ownedFromCart(cart, currentAtoms);
      var items = pool.filter(function (p) {
        return !suppressed({ handle: p.h, atoms: p.a || [], pack: p.pack }, ctx, current, false);
      });
      /* Mise en avant des packs : tri STABLE packs d'abord, puis produits seuls (le serveur les emet deja
         dans cet ordre ; on securise si la collection source est reordonnee). Puis on coupe a `max`. */
      items.sort(function (a, b) { return (b.pack ? 1 : 0) - (a.pack ? 1 : 0); });
      items = items.slice(0, max);
      if (items.length < min) { host.hidden = true; return; }
      listEl.innerHTML = items.map(card).join('');
      host.hidden = false;
    });
  }

  /* ---------- Deplacement de lignes (encart + tiroir) ----------
     Les lignes sont rendues serveur (avec form natif) dans un reservoir persistant.
     On DEPLACE les survivantes (appendChild) : jamais recopiees => images conservees. */
  function collectRows(reservoir) {
    var rows = [];
    reservoir.querySelectorAll('[data-mx-xsell-xrow]').forEach(function (row) {
      rows.push({
        node: row,
        handle: row.getAttribute('data-handle'),
        atoms: parseAtoms(row.getAttribute('data-atoms')),
        pack: row.getAttribute('data-pack') === 'true'
      });
    });
    return rows;
  }
  function fillList(listNode, reservoir, rows, ctx, current, noPacks, max) {
    rows.forEach(function (r) { r.node.hidden = true; reservoir.appendChild(r.node); });
    var shown = 0;
    for (var i = 0; i < rows.length && shown < max; i++) {
      var r = rows[i];
      if (suppressed(r, ctx, current, noPacks)) continue;
      r.node.hidden = false;
      listNode.appendChild(r.node);
      shown++;
    }
    return shown;
  }

  /* ENCART PDP : insere pres du bloc d'achat, calcule une fois au chargement. */
  function encart() {
    var host = document.querySelector('[data-mx-xsell-encart]');
    if (!host) return;
    var reservoir = host.querySelector('[data-mx-xsell-encart-reservoir]');
    if (!reservoir) return;
    var rows = collectRows(reservoir);
    if (!rows.length) return;
    var current = host.getAttribute('data-current') || currentHandle();
    var max = parseInt(host.getAttribute('data-max') || '2', 10);
    var min = parseInt(host.getAttribute('data-min') || '1', 10);
    var title = host.getAttribute('data-title') || '';
    var sel = host.getAttribute('data-anchor') || '';
    /* Ancre = le VRAI formulaire produit de la fiche. On exclut les formulaires des lignes cross-sell
       (.mx-xsell-xrow__pf) et tout ce qui est dans le tiroir / un reservoir : sinon, comme le groupe
       panier est rendu AVANT le contenu, querySelector('product-form') attrape une ligne du tiroir
       -> l'encart s'insere au mauvais endroit (disposition cassee). */
    var EXCL = 'cart-drawer,[data-mx-xsell-cart],[data-mx-xsell-cart-reservoir],[data-mx-xsell-encart-reservoir]';
    function pickForm(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.classList && n.classList.contains('mx-xsell-xrow__pf')) continue;
        if (n.classList && n.classList.contains('mx-xsell-xrow__form')) continue;
        if (n.closest && n.closest(EXCL)) continue;
        return n;
      }
      return null;
    }
    var anchor = (sel && document.querySelector(sel))
      || pickForm(document.querySelectorAll('product-form'))
      || pickForm(document.querySelectorAll('form[action$="/cart/add"]'));
    if (!anchor || !anchor.parentNode) return;
    if (document.querySelector('[data-mx-xsell-encart-live]')) return;
    /* Atomes de la fiche courante : lus sur l'hote (data-atoms rendu serveur). L'encart exclut le produit
       courant du reservoir, donc on ne peut PAS retrouver ses atomes dans les lignes -> data-atoms est la
       seule source fiable (pack inclus). Repli sur le reservoir par securite. */
    var currentAtoms = parseAtoms(host.getAttribute('data-atoms'));
    if (!currentAtoms.length) rows.forEach(function (r) { if (r.handle === current) currentAtoms = r.atoms; });
    getCart(function (cart) {
      if (document.querySelector('[data-mx-xsell-encart-live]')) return;
      var ctx = ownedFromCart(cart, currentAtoms);
      var box = document.createElement('div');
      box.className = 'mx-xsell mx-xsell-xg mx-xsell-xg--encart';
      box.setAttribute('data-mx-xsell-encart-live', '');
      if (title) {
        var h = document.createElement('div');
        h.className = 'mx-xsell-xg__title';
        h.textContent = title;
        box.appendChild(h);
      }
      var list = document.createElement('div');
      list.className = 'mx-xsell-xg__row';
      var n = fillList(list, reservoir, rows, ctx, current, true, max);
      if (n < min) return;
      box.appendChild(list);
      /* Inserer APRES la ligne de reassurance si elle existe (sinon juste apres le formulaire),
         pour que le cross-sell reste sous la reassurance. */
      var ref = anchor;
      var scope = (anchor.closest && anchor.closest('.shopify-section, main, .product-section')) || document;
      var reass = scope.querySelector('.mx-xsell-reassure');
      if (reass && reass.parentNode && (anchor.compareDocumentPosition(reass) & 4)) ref = reass; /* 4 = FOLLOWING */
      ref.parentNode.insertBefore(box, ref.nextSibling);
    });
  }

  /* TIROIR : hote persistant reinsere par MutationObserver ; reshuffle sur changement de panier. */
  function cartDrawer() {
    var host = document.querySelector('[data-mx-xsell-cart]');
    if (!host) return;
    var reservoir = host.querySelector('[data-mx-xsell-cart-reservoir]');
    if (!reservoir) return;
    var rows = collectRows(reservoir);
    if (!rows.length) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var max = parseInt(host.getAttribute('data-max') || '3', 10);
    var min = parseInt(host.getAttribute('data-min') || '1', 10);
    var title = host.getAttribute('data-title') || '';
    var insertSel = host.getAttribute('data-insert') || '';

    var block = document.createElement('div');
    block.className = 'mx-xsell mx-xsell-xg mx-xsell-xg--drawer';
    block.setAttribute('data-mx-xsell-cart-live', '');
    // En-tete : titre + fleches dessinees (defilement produit par produit ; la barre de defilement est masquee en CSS)
    var head = document.createElement('div');
    head.className = 'mx-xsell-xg__head';
    if (title) {
      var h = document.createElement('div');
      h.className = 'mx-xsell-xg__title';
      h.textContent = title;
      head.appendChild(h);
    }
    var nav = document.createElement('div');
    nav.className = 'mx-xsell-xg__nav';
    nav.innerHTML = '<button type="button" class="mx-xsell-xg__arrow mx-xsell-xg__arrow--prev" aria-label="' + esc(host.getAttribute('data-label-prev') || 'Produit precedent') + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      + '<button type="button" class="mx-xsell-xg__arrow mx-xsell-xg__arrow--next" aria-label="' + esc(host.getAttribute('data-label-next') || 'Produit suivant') + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    head.appendChild(nav);
    block.appendChild(head);
    var list = document.createElement('div');
    list.className = 'mx-xsell-xg__row';
    block.appendChild(list);
    block._empty = true;
    var prev = nav.firstElementChild, next = nav.lastElementChild;
    function step() {
      var first = list.querySelector('.mx-xsell-xrow:not([hidden])');
      if (!first) return list.clientWidth;
      var cs = getComputedStyle(list);
      return first.getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 8);
    }
    function state() {
      var over = list.scrollWidth > list.clientWidth + 2;
      nav.hidden = !over;
      if (!over) return;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
    list.addEventListener('scroll', state, { passive: true });
    window.addEventListener('resize', state);
    block._state = state;

    var lastToken = null;
    var pending = false;

    function place() {
      if (!drawer.classList.contains('is-open')) return;
      if (block._empty) { if (block.parentNode) block.parentNode.removeChild(block); return; }
      if (block.parentNode) return;
      var target = (insertSel && drawer.querySelector(insertSel)) || drawer.querySelector('.cart-drawer__footer');
      if (target && target.parentNode) target.parentNode.insertBefore(block, target);
      else (drawer.querySelector('[data-mx-xsell-cart-anchor]') || drawer).appendChild(block);
      requestAnimationFrame(function () { if (block._state) block._state(); });
    }
    function tick() {
      if (!drawer.classList.contains('is-open')) return;
      getCart(function (cart) {
        var tok = cartToken(cart);
        if (tok !== lastToken) {
          var ctx = ownedFromCart(cart, []);
          var n = fillList(list, reservoir, rows, ctx, '', true, max);
          block._empty = (n < min) || !(cart.item_count > 0);
          lastToken = tok;
          list.scrollLeft = 0;
        }
        place();
        if (block._state) block._state();
      });
    }

    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; tick(); });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });

    if (drawer.classList.contains('is-open')) tick();
  }

  /* Ajout AJAX depuis une ligne cross-sell : reproduit le contrat du theme (cf. assets/quick-add.js) :
     POST Theme.routes.cart_add_url puis event 'cart:updated' (sections re-rendues) -> le tiroir se met a
     jour SANS redirection vers /cart. Capture au niveau document + stopImmediatePropagation : neutralise le
     POST natif du {% form 'product' %} (la redirection) et un eventuel <product-form> du theme (double ajout). */
  function cartAddUrl(){ return (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js'; }
  function onXsellSubmit(e){
    var form = e.target;
    if(!form || !form.classList || !form.classList.contains('mx-xsell-xrow__form')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd; try{ fd = new FormData(form); }catch(_){ return; }
    var id = fd.get('id'); if(!id) return;
    var item = { id: id, quantity: 1 }, props = {}, hasProps = false;
    fd.forEach(function(v,k){ var m=/^properties\[(.+)\]$/.exec(k); if(m){ props[m[1]]=v; hasProps=true; } });
    if(hasProps) item.properties = props;
    var sections = [], cd = document.querySelector('cart-drawer');
    if(cd && cd.dataset && cd.dataset.sectionId) sections.push(cd.dataset.sectionId);
    sections.push('auto-gifts');
    var btn = form.querySelector('[name="add"],button[type="submit"]');
    if(btn){ btn.classList.add('is-loading'); btn.disabled = true; }
    function done(){ if(btn){ btn.classList.remove('is-loading'); btn.disabled = false; } }
    fetch(cartAddUrl(), {
      method:'POST',
      headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ items:[item], sections: sections.join(',') })
    }).then(function(r){ return r.json().catch(function(){ return null; }); }).then(function(data){
      done();
      if(data && (data.status >= 400 || data.status === 'bad_request')){
        try{ document.dispatchEvent(new CustomEvent('toast:open',{detail:{type:'error',message:(data.description||data.message||'')}})); }catch(_){}
        return;
      }
      if(/\/cart(\/|$|\?)/.test(location.pathname)){ location.reload(); return; }
      var cnt; try{ var ci=document.querySelector('cart-icon'); if(ci && ci.getCurrentItemCount) cnt=ci.getCurrentItemCount()+1; }catch(_){}
      var ev; try{ ev=new Event('cart:updated',{bubbles:true}); }catch(_){ ev=document.createEvent('Event'); ev.initEvent('cart:updated',true,false); }
      ev.detail = { resource:{}, data:{ itemCount:(typeof cnt==='number'&&!isNaN(cnt))?cnt:undefined, source:'mx-xsell', sections:(data&&data.sections)||undefined } };
      document.dispatchEvent(ev);
      /* cart:updated ne fait que RE-RENDRE le tiroir (cart-drawer.js), il ne l'OUVRE pas (c'est cart:open).
         On ouvre donc explicitement selon le reglage (open_cart -> tiroir ; sinon -> toast succes),
         pour que l'ajout soit toujours visible. Corrige le "parfois ca n'ajoute pas" (l'article etait
         bien ajoute mais le tiroir restait ferme). */
      var beh='open_cart'; try{ var ci2=document.querySelector('cart-icon'); if(ci2&&ci2.addToCartBehavior) beh=ci2.addToCartBehavior; }catch(_){}
      if(beh==='open_cart' && document.querySelector('cart-drawer')){
        try{ document.dispatchEvent(new Event('cart:open',{bubbles:true})); }catch(_){}
      } else if(beh!=='open_cart'){
        try{ document.dispatchEvent(new CustomEvent('toast:open',{detail:{type:'success',message:(window.Theme&&Theme.translations&&Theme.translations.addToCartNotificationMessage)||''}})); }catch(_){}
      }
    }).catch(function(){ done(); });
  }

  function boot() {
    ATOMS = window.MX_ATOMS || ATOMS;
    document.addEventListener('submit', onXsellSubmit, true);
    grid();
    encart();
    cartDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
